import RESTFUL_axios from '@/api/restful_axois';
import apiError from '@/api/apierror';

const RESTFUL_fn = function (apiType, reqData) {
  var apiName = 'serverTime';
  var reqName = apiName + '_' + apiType;
  var apiConfigs = {
    _get: {
      url: '/saasajax/server.ajax.php?action=getNServeTime',
      // url: '/saasajax/server.ajax.php?action=getServeTime',
      data: function (reqData) {
        return {};
      },
      attrs: {
        withCredentials: false
      },
      transformResponse: function (res) {
        switch (res.error_info.errno) {
          case 1:
            var resData = res.data;
            var localData = {
              serverTime: resData.serveTime * 1000
            }
            return localData
          default:
            apiError({
              name: reqName,
              code: res.error_info.errno,
              intro: res.error_info.error,
              url: this.url,
              req: reqData,
              res: res
            })
        }
      }
    }
  }
  return RESTFUL_axios({
    reqName: reqName,
    reqConfig: apiConfigs['_' + apiType],
    reqData: reqData,
  });
};

export default RESTFUL_fn